import * as React from 'react';

import PropTypes from 'prop-types';

import PhoenixEnrollModal from 'bundles/certificate-enroll/components/PhoenixEnrollModal';

type Props = {
  // Original propType: object.isRequired
  course: $TSFixMe;
  isPreEnroll: boolean;
  children: React.ReactNode;
};

class OpencourseEnrollModal extends React.Component<Props> {
  static childContextTypes = {
    course: PropTypes.object,
  };

  getChildContext() {
    const { course } = this.props;
    return { course };
  }

  render() {
    const { isPreEnroll } = this.props;
    return (
      <div className="rc-OpencourseEnrollModal" id="OpenCourseEnrollModal">
        {/* both pre-enroll and enroll modals display cert vs free option */}
        {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
        <PhoenixEnrollModal isPreEnroll={isPreEnroll}>{this.props.children}</PhoenixEnrollModal>
      </div>
    );
  }
}

export default OpencourseEnrollModal;
